import 'select2/dist/js/select2.full.min.js';

export default () => {

  $(document).ready(function() {

     // SELECT2
    $(".gl-category-dropdown-selection").select2({
      placeholder: "Category",
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "gl-big-search-drop"
    });

     $(".gl-realestate-category-selection").select2({
      placeholder: "Category",
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "gl-realestate-drop"
    });

     $(".gl-realestate-type-selection").select2({
      placeholder: "Type",
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "gl-realestate-drop"
    });

    $(".gl-location-selection").select2({
      placeholder: "Canada",
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "gl-location-drop"
    });

    $(".gl--search-category-selection").select2({
      placeholder: "Category",
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "gl-search-category-drop"
    });

    $(".gl-sort-selection").select2({
      placeholder: "Category",
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "gl-sorting-drop"
    });
  });

};



/** WEBPACK FOOTER **
 ** ./assets/src/js/selectbox/selectDropdown.js
 **/